import { render } from "./ag-passwod.vue?vue&type=template&id=5742b99a&scoped=true"
import script from "./ag-passwod.vue?vue&type=script&lang=js"
export * from "./ag-passwod.vue?vue&type=script&lang=js"

import "./ag-passwod.vue?vue&type=style&index=0&id=5742b99a&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\jenkinsuser\\AppData\\Local\\Jenkins\\.jenkins\\workspace\\UI\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5742b99a"]])

export default __exports__